import { FaListUl } from 'react-icons/fa';
import React, { Component } from 'react';


class CustomData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: false,
            filterBy: {},
            sortBy: 'DisplayName',
            sortOrder: 1,
            loading: false,
            type: "special"
        };
    }
    cancel = () => {
        this.setState({ editData: false, tempData: false, loading: false, error: '' })
    }
    editData = (id) => e => {
        var item = this.props.data.CustomData.data.find(function (element) {
            return element.id === id;
        });
        this.setState({ editData: true, tempData: item, loading: false, error: '' })
    }
    // add = () => {
    //     this.setState({ editData: true, promptID: null, loading: false, error: '' })
    // }

    checkEnter = (e) => {
        if (e.keyCode === 13) {
            this.confirmEdit();
        }
    }
    toggle = (param) => (e) => {
        var newState = Object.assign({}, this.state)
        newState[param] = this.state[param] ? false : true
        this.setState(newState)
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.loading) {
            this.cancel()
        }
    }
    handleTempDataValueChange = (e, index) => {
        const newValue = e.target.value;

        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            if (Array.isArray(updatedTempData.value)) {
                updatedTempData.value[index] = newValue;
            } else {
                updatedTempData.value = newValue;
            }
            return { tempData: updatedTempData };
        });
    }

    handleTempDataObjectValueChange = (key) => (e) => {
        const isCheckbox = e && e.target && e.target.type === 'checkbox';
        const raw = isCheckbox ? e.target.checked : e.target.value;

        this.setState(prevState => {
            const updated = { ...prevState.tempData };
            const currentObj = { ...(updated.value || {}) };
            const currentVal = currentObj[key];

            let nextVal;
            if (typeof currentVal === 'number') {
                nextVal = raw === '' ? '' : Number(raw);
            } else if (typeof currentVal === 'boolean') {
                nextVal = Boolean(raw);
            } else {
                nextVal = raw;
            }

            currentObj[key] = nextVal;
            updated.value = currentObj;
            return { tempData: updated };
        });
    }
    toggleTempDataValue = (e) => {
        this.setState(prevState => {
            const updatedTempData = { ...prevState.tempData };
            updatedTempData.value = !updatedTempData.value;
            return { tempData: updatedTempData };
        })
    }

    confirmEdit = () => {
        // Add your logic here to handle confirming the edit
        this.setState({ loading: true })
        var tempData = this.state.tempData
        tempData.creationDate = new Date().toJSON()
        this.props.ws.send(JSON.stringify({ route: 'updateCustomData', data: tempData }))
        //update state to not be editing
        this.setState({ editData: false, loading: false, tempData: null })
    }


    sort = (sortBy) => (e) => {
        var sortOrder
        if (this.state.sortOrder === -1) {
            sortOrder = 1;
        } else {
            sortOrder = -1;
        }
        this.setState({ sortBy: sortBy, sortOrder: sortOrder })
    }

    filter = (field) => (e) => {
        var filterBy = this.state.filterBy
        if (e.target.value.length > 0) {
            filterBy[field] = e.target.value
        } else {
            delete filterBy[field]
        }
        this.setState({ filterBy: filterBy })
    }

    sortFunc(sortBy, sortOrder) {
        return function (a, b) {

            if (sortBy in a && sortBy in b) {
                if (a[sortBy] === b[sortBy]) {
                    return a.DisplayName > b.DisplayName ? 1 * sortOrder : -1 * sortOrder
                }
                return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
            }
        }
    }
    checkCategory = (e) => {
        console.log(e.target.value)
        this.setState({ category: e.target.value })
    }
    filterFunc(array, filterBy) {
        return array.filter(function (object) {
            for (var prop in filterBy) {
                if (typeof object[prop] === "undefined") {
                    return false
                }
                if (prop === 'language') {
                    if (object[prop].indexOf(filterBy[prop]) < 0) {
                        return false
                    }

                } else {
                    if (object[prop].toString().toLowerCase().indexOf(filterBy[prop].toString().toLowerCase()) < 0) {
                        return false
                    }
                }

            }
            return true
        })
    }

    filterIcon(item) {
        return (this.state.sortBy === item ? (this.state.sortOrder == 1) ? " \u25B2" : " \u25BC" : "")
    }

    filterByDropdown = (value) => {
        var filterBy = this.state.filterBy
        if (!value) {
            delete filterBy.is_enabled
        } else if (value.id == 1) {
            filterBy.is_enabled = true
        } else if (value.id == 0) {
            filterBy.is_enabled = false
        }
        this.setState({ filterBy: filterBy })

    }

    renderValuePreview = (val) => {
        if (val === null || typeof val === 'undefined') return '';

        // Simple primitives
        if (typeof val === 'boolean') return val ? 'Active' : 'Inactive';
        if (typeof val === 'number' || typeof val === 'string') return String(val);

        // Arrays
        if (Array.isArray(val)) {
            const previewTitle = val.map(v => String(v)).join(', ');
            return (
                <span title={previewTitle} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                    <FaListUl style={{ marginRight: '2px' }} />
                    {val.length} item{val.length === 1 ? '' : 's'}
                </span>
            );
        }

        // Objects
        if (typeof val === 'object') {
            const keys = Object.keys(val || {});
            const values = Object.values(val || {});
            const allBooleans = values.every(v => typeof v === 'boolean');

            // Special case: a boolean map — show how many are enabled
            if (allBooleans) {
                const enabled = values.filter(Boolean).length;
                return (
                    <span title={JSON.stringify(val)}>
                        {enabled}/{keys.length} Enabled
                    </span>
                );
            }

            // Generic object: compact summary (no preview pairs)
            return (
                <span title={JSON.stringify(val)}>
                    {keys.length} field{keys.length === 1 ? '' : 's'}
                </span>
            );
        }

        // Fallback
        return String(val);
    }

    render() {
        if (this.props.active) {

            const categories = Array.isArray(this.props.data.CustomData.settings.categories)
                ? this.props.data.CustomData.settings.categories
                : [];
            const activeCategory = (this.state.category !== "" && this.state.category !== undefined)
                ? this.state.category
                : (categories.length > 0 ? categories[0] : "");



            var dataList = []
            var CustomData = JSON.parse(JSON.stringify(this.props.data.CustomData.data));
            // //Filtering List
            if (Object.keys(this.state.filterBy).length > 0) {
                CustomData = this.filterFunc(CustomData, this.state.filterBy)
            }
            // //Sorting List
            if (this.state.sortBy !== '') {
                CustomData.sort(this.sortFunc(this.state.sortBy, this.state.sortOrder))
            }

            //Filter data by type
            if (activeCategory !== "") {
                CustomData = CustomData.filter(function (object) {
                    return object && object.category === activeCategory;
                });
            }


            for (var data of CustomData) {
                dataList.push(
                    <tr className="dataRow" onClick={this.editData(data.id)} key={data.id}>
                        <td style={{ flex: '0 0 300px', textAlign: 'left' }}>{data.name}</td>
                        <td style={{ flex: '0 0 150px', textAlign: 'left' }}>
                            {this.renderValuePreview(data.value)}
                        </td>
                        <td style={{ flex: '0 0 180px', textAlign: 'right' }}>{data.lastUpdatedUser}</td>
                        <td style={{ flex: '0 0 200px', textAlign: 'right' }}>{data.lastUpdatedDate}</td>
                    </tr>
                );
            }

            var editData = "";
            if (this.state.editData) {
                let inputElements = null;

                if (Array.isArray(this.state.tempData.value)) {
                    inputElements = (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', width: '100%' }}>
                            {this.state.tempData.value.map((item, index) => (
                                <input
                                    key={index}
                                    type="text"
                                    value={item}
                                    onChange={(e) => this.handleTempDataValueChange(e, index)}
                                    style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                                />
                            ))}
                            <input
                                key={this.state.tempData.value.length}
                                type="text"
                                value=""
                                onChange={(e) => this.handleTempDataValueChange(e, this.state.tempData.value.length)}
                                ref={this.newInput} // Save a reference to the input element
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            />
                        </div>
                    );
                } else if (
                    this.state.tempData &&
                    this.state.tempData.value &&
                    typeof this.state.tempData.value === 'object' &&
                    !Array.isArray(this.state.tempData.value)
                ) {
                    const objEntries = Object.entries(this.state.tempData.value);
                    inputElements = (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', alignItems: 'center' }}>
                            {objEntries.map(([k, v], idx) => {
                                const label = String(k);
                                if (typeof v === 'boolean') {
                                    return (
                                        <label key={k} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <input
                                                type="checkbox"
                                                checked={Boolean(v)}
                                                onChange={this.handleTempDataObjectValueChange(k)}
                                            />
                                            <span>{label}</span>
                                        </label>
                                    );
                                } else if (typeof v === 'number') {
                                    return (
                                        <div key={k} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span style={{ marginBottom: '4px' }}>{label}</span>
                                            <input
                                                type="number"
                                                value={v}
                                                onChange={this.handleTempDataObjectValueChange(k)}
                                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px' }}
                                                step="1"
                                            />
                                        </div>
                                    );
                                } else {
                                    // default to text input for strings/other primitives
                                    return (
                                        <div key={k} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                            <span style={{ marginBottom: '4px' }}>{label}</span>
                                            <input
                                                type="text"
                                                value={v == null ? '' : v}
                                                onChange={this.handleTempDataObjectValueChange(k)}
                                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px' }}
                                            />
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    );
                } else if (typeof this.state.tempData.value === 'boolean') {
                    inputElements = (
                        <select
                            value={this.state.tempData.value}
                            onChange={this.toggleTempDataValue}
                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                        >
                            <option value={true}>Active</option>
                            <option value={false}>Inactive</option>
                        </select>
                    );
                } else if (typeof this.state.tempData.value === 'number') {
                    // Input field for integer numbers
                    inputElements = (
                        <input
                            type="number"
                            value={this.state.tempData.value}
                            onChange={this.handleTempDataValueChange}
                            style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            step="1"  // Ensure the input only allows integers
                        />
                    );
                } else {
                    if (this.state.tempData.options != undefined) {
                        // Build out options for dropdown
                        var options = []
                        for (var option of this.state.tempData.options) {
                            options.push(<option value={option}>{option}</option>)
                        }

                        inputElements = (
                            <select
                                value={this.state.tempData.value}
                                onChange={this.handleTempDataValueChange}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            >
                                {options}
                            </select>
                        );
                    } else {
                        inputElements = (
                            <input
                                type="text"
                                value={this.state.tempData.value}
                                onChange={this.handleTempDataValueChange}
                                style={{ width: '250px', padding: '8px', border: '1px solid #999', borderRadius: '4px', marginBottom: '10px' }}
                            />
                        );
                    }
                }

                editData = (
                    <div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
                        <div className="pop" style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            maxWidth: '400px',  // Limit the width to keep the modal small
                            padding: '45px'     // Add padding for better spacing
                        }}>
                            <div className="viewCloser" onClick={this.cancel}></div>
                            <div className="error">{this.state.error}</div>

                            {/* Display the current tempData Name */}
                            <h2 style={{ marginBottom: '1px', fontSize: '1.5rem', textAlign: 'center' }}>
                                {this.state.tempData.name}
                            </h2>

                            {/* Display the tempData Description (Non-editable, text wraps) */}
                            <p style={{
                                marginBottom: '30px',
                                fontSize: '1rem',
                                color: '#666',
                                textAlign: 'center',
                                wordWrap: 'break-word',   // Ensure long words break and wrap
                                whiteSpace: 'normal'      // Allow regular text wrapping
                            }}>
                                {this.state.tempData.description}
                            </p>

                            {/* Edit box for the value */}
                            {inputElements}

                            {/* Confirm button */}
                            <button
                                className="button"
                                onClick={this.confirmEdit}
                                style={{ border: 'none', cursor: 'pointer', marginTop: '20px' }}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                );
            }











            return (
                <div width="100%">
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ width: '200px', marginRight: '50px', marginTop: '2px' }}>
                            <div style={{ display: 'flex', alignItems: 'left', marginBottom: '20px', marginTop: '10px' }}>
                                <label className="switch">
                                    <div style={{ width: '250px' }}>
                                        {categories && categories.length > 0 && (
                                            <select
                                                value={activeCategory}
                                                onChange={this.checkCategory}
                                                style={{
                                                    display: 'inline-block',
                                                    flex: '1 0 0',
                                                    marginBottom: '5px',
                                                    height: '40px',
                                                    padding: '0 10px',
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold',
                                                    fontSize: '20px',
                                                    color: '#137',
                                                    lineHeight: '24px'
                                                }}
                                            >
                                                {categories.map((category, index) => (
                                                    <option key={index} value={category}>
                                                        {category}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </label>
                            </div>
                            <div className="filterBox" style={{
                                "width": "210px"
                            }}>

                                <h4>Filter By:</h4>
                                <div style={{ width: '150px' }}>
                                    <label>Name:</label>
                                    <input type="text" onChange={this.filter("name")} value={this.state.filterBy.DisplayName} />
                                </div>
                                <div style={{ width: '150px' }}>
                                    <label>User:   </label>
                                    <input type="text" onChange={this.filter("lastUpdatedUser")} value={this.state.filterBy.User} />
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: 1 }}>
                            <table style={{ float: "left" }}>
                                <thead>
                                    <tr className="dataRow">
                                        <th style={{ minWidth: '300px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("name")}>Name {this.filterIcon("name")}</th>
                                        <th style={{ minWidth: '150px', cursor: 'pointer', textAlign: 'left' }} onClick={this.sort("value")}>Value {this.filterIcon("value")}</th>
                                        <th style={{ minWidth: '180px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("lastUpdatedUser")}>Last Updated User {this.filterIcon("lastUpdatedUser")}</th>
                                        <th style={{ minWidth: '200px', cursor: 'pointer', textAlign: 'right' }} onClick={this.sort("lastUpdatedDate")}>Last Updated {this.filterIcon("lastUpdatedDate")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataList}
                                </tbody>
                            </table>
                        </div>
                    </div >
                    {editData}
                </div >
            );
        } else {
            return (
                <div width="100%">

                </div>
            );
        }
    }
}


const icon = "menuWorkflow"
const roles = ["View"]
export { CustomData, icon, roles }